import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import {
  Button,
  IconButton,
  Stack,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { FormTextField } from "UI/FormTextField";
import { DialogWindow } from "UI/DialogWindow";
import { ButtonInfo } from "./ReferralForm.common";

export const QuestionForm = ({
  handleResetAndBack,
  recipientName,
  provider,
  sender,
  control,
  // watch,
  isButtonEnabled,
  loading,
  onQuestionSubmit,
  handleClose = null,
}) => {
  // const buttonType = watch("buttonType");
  // const isVirtual = ["Virtual", "Soft", "Digital"].includes(buttonType);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <DialogWindow
      open
      handleClose={handleClose}
      withCloseButton={!!handleClose}
      title={
        <Stack direction={"row"} alignItems={"center"} gap={1}>
          <IconButton aria-label="close" onClick={handleResetAndBack}>
            <ArrowBackIosNewIcon />
          </IconButton>
          Ask a Question
        </Stack>
      }
      content={
        <Stack gap={2} minWidth={isMobile ? undefined : 400}>
          <ButtonInfo
            recipientName={recipientName}
            provider={provider}
            sender={sender}
          />
          <Stack direction={"column"} alignItems={"flex-start"}>
            <FormTextField
              id="question"
              name="question"
              placeholder="Type your question here"
              control={control}
              rules={{ required: "is required" }}
              InputProps={{
                autoComplete: "off",
              }}
              multiline
              sx={{
                "& textarea": {
                  minHeight: 150,
                },
              }}
            />
          </Stack>
        </Stack>
      }
      actions={
        <Stack
          flex={1}
          direction={"row"}
          gap={1}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Button
            variant="contained"
            color="primary"
            disabled={!isButtonEnabled || loading}
            onClick={onQuestionSubmit}
          >
            Send
          </Button>
        </Stack>
      }
    />
  );
};
